const MobileInterface = {
  openLink(url) {

    if (window.AndroidInterface) {
      //use android interface
      window.AndroidInterface.openLink(url)
    } else {
      //try ios interface
      try {
        window.webkit.messageHandlers.openLink.postMessage(url);
      } catch (error) {
        //fallback
         window.open(url, '_blank');
      }
    }
  },

  setOneSignalExternalUserId(id) {

    if (window.AndroidInterface) {
      //use android interface
      window.AndroidInterface.setOneSignalExternalUserId(id);
    } else {
      //try ios interface
      try {
        window.webkit.messageHandlers.setOneSignalExternalUserId.postMessage(id);
      } catch (error) {
        //fallback
        //erro
      }
    }
  },

  getClientPlatformType() {
    return new Promise((resolve) => {

      if (window.AndroidInterface) {
        //use android interface
        resolve(window.AndroidInterface.getClientPlatformType());
      } else {
        //try ios interface
        try {
          window.webkit.messageHandlers.getClientPlatformType.postMessage(null);

          function clientPlatformTypeHandler(event) {
            resolve(event.detail);
            window.removeEventListener('clientPlatformTypeResponse', clientPlatformTypeHandler);
          }

          window.addEventListener('clientPlatformTypeResponse', clientPlatformTypeHandler);

        } catch (error) {
          //fallback for web
          resolve("web");
        }
      }

    })
  },

  getClientVersion() {
    return new Promise((resolve) => {

      if (window.AndroidInterface) {
        //use android interface
        resolve(window.AndroidInterface.getClientVersion());
      } else {
        //try ios interface
        try {
          window.webkit.messageHandlers.getClientVersion.postMessage(null);

          function clientVersionHandler(event) {
            resolve(event.detail);
            window.removeEventListener('clientVersionResponse', clientVersionHandler);
          }

          window.addEventListener('clientVersionResponse', clientVersionHandler);

        } catch (error) {
          //fallback
          resolve("1.0");
        }
      }

    })
  },

  checkLocationPermission() {
    return new Promise((resolve) => {

      if (window.AndroidInterface) {
        //use android interface
        resolve(window.AndroidInterface.checkLocationPermission());
      } else {
        //try ios interface
        try {
          window.webkit.messageHandlers.checkLocationPermission.postMessage(null);

          function handler(event) {

            if (event.detail === 'yes') {
              resolve(true);
            } else {
              resolve(false);
            }

            window.removeEventListener('checkLocationPermissionResponse', handler);
          }

          window.addEventListener('checkLocationPermissionResponse', handler);

        } catch (error) {
          //fallback
          resolve(false);
        }
      }

    })
  },

  requestLocationPermission() {
    if (window.AndroidInterface) {
      //use android interface
      window.AndroidInterface.requestLocationPermission()
    } else {
      //try ios interface
      try {
        window.webkit.messageHandlers.requestLocationPermission.postMessage(null);

      } catch (error) {
        //fallback
        //erro
      }
    }
  },
  showLocationSettingsAlert() {

    if (window.AndroidInterface) {
      //use android interface
      window.AndroidInterface.showLocationSettingsAlert()
    } else {
      //try ios interface
      try {
        window.webkit.messageHandlers.showLocationSettingsAlert.postMessage(null);

      } catch (error) {
        //fallback
        //erro
      }
    }
  },

  isLocationEnabled() {
    return new Promise((resolve) => {

      if (window.AndroidInterface) {
        //use android interface
        resolve(window.AndroidInterface.isLocationEnabled());
      } else {
        //try ios interface
        try {
          window.webkit.messageHandlers.isLocationEnabled.postMessage(null);

          function handler(event) {
            if (event.detail === 'yes') {
              resolve(true);
            } else {
              resolve(false);
            }

            window.removeEventListener('isLocationEnabledResponse', handler);
          }

          window.addEventListener('isLocationEnabledResponse', handler);

        } catch (error) {
          //fallback
          resolve(false);
        }
      }

    })
  },

  requestCurrentLocation() {
    return new Promise((resolve) => {

      if (window.AndroidInterface) {
        //use android interface
        resolve(window.AndroidInterface.requestCurrentLocation());
      } else {
        //try ios interface
        try {
          window.webkit.messageHandlers.requestCurrentLocation.postMessage(null);

          function handler(event) {
            resolve(event.detail);
            window.removeEventListener('requestCurrentLocationResponse', handler);
          }

          window.addEventListener('requestCurrentLocationResponse', handler);

        } catch (error) {
          // Web fallback
          if (navigator.geolocation) {
            let resolved = false;

            // fallback timeout (e.g. 3 seconds)
            const timeout = setTimeout(() => {
              if (!resolved) {
                resolved = true;
                resolve("unavailable");
              }
            }, 10000);

            navigator.geolocation.getCurrentPosition(
              (position) => {
                if (!resolved) {
                  clearTimeout(timeout);
                  resolved = true;
                  const { latitude, longitude } = position.coords;
                  const userLocation = { lat: latitude, lng: longitude };
                  console.log("User Loc 1", userLocation);
                  
                  resolve(JSON.stringify(userLocation));
                }
              },
              (err) => {
                if (!resolved) {
                  clearTimeout(timeout);
                  resolved = true;
                  console.error("Error detecting location:", err.message);
                  resolve("unavailable");
                }
              }
            );
          } else {
            resolve("unavailable");
          }
        }
      }

    })
  },
}

export default MobileInterface;

